
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/contact",
      function () {
        return require("private-next-pages/actuary/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/contact"])
      });
    }
  